var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08 22.75c-1.57 0-2.86-1.26-2.86-2.82V5.09c0-1.53.57-2.72 1.61-3.37 1.05-.66 2.41-.64 3.82.06l4.44 2.18c1.21.6 2.16 2.11 2.16 3.45V22c0 .41-.34.75-.75.75H4.08zM3.62 3c-.58.36-.9 1.11-.9 2.09v14.84c0 .73.61 1.32 1.36 1.32h7.67V7.41c0-.77-.62-1.76-1.33-2.1L5.98 3.13c-.51-.25-.99-.38-1.42-.38-.35 0-.67.08-.94.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.75c-.41 0-.75-.34-.75-.75V10.42c0-.23.1-.44.28-.58.18-.14.4-.2.63-.15l.47.1 6.54 1.46c1.99.44 2.99 1.61 3.05 3.6.01 0 .01.1.01.21v3.78c-.01 2.56-1.36 3.91-3.92 3.91H12.5zm6.31-1.5c1.76 0 2.41-.65 2.41-2.41v-3.86c-.05-1.37-.57-1.98-1.88-2.27l-6.09-1.36v9.9h5.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.47a.749.749 0 1 1 0 1.5H5.5zM5.5 13.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.47a.749.749 0 1 1 0 1.5H5.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.22 14.75v-4.23c0-.23.1-.44.28-.59.18-.15.41-.2.63-.15l4.5 1.01c.34.08.59.38.59.73v3.22c0 1.66-1.34 3.01-3 3.01-1.65 0-3-1.35-3-3zm1.5 0c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-2.62l-3-.67v3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.72 14.75v-3.22c0-.23.1-.44.28-.58.18-.14.41-.2.63-.15l2.03.45c1.99.44 2.99 1.61 3.05 3.6v.06a2.99 2.99 0 0 1-2.99 2.84c-1.65 0-3-1.35-3-3zm1.5 0a1.498 1.498 0 0 0 2.99.11c-.05-1.26-.57-1.86-1.87-2.15l-1.12-.25v2.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBuilding);
export default __webpack_public_path__ + "static/media/vuesax-outline-building.bf524c8e5ca6f0c506e81d7b19be5e93.svg";
export { ForwardRef as ReactComponent };